window.addEventListener('DOMContentLoaded', () => {
    const header = document.getElementById('header');
    const headerContent = header.querySelector('.header__content');
    const links = document.querySelectorAll('.nav-item__children');
    const navBar = document.querySelector('.nav-bar');
    let activeLink = null;

    Array.from(links).forEach((link) => {
        link.addEventListener('mouseenter', () => {
            if (activeLink && activeLink !== link) {
                activeLink.classList.remove('nav-item--active');
            }

            activeLink = link;
            link.classList.add('nav-item--active');
            header.classList.add('header--active');

            resize();

            const content = link.querySelector('.nav-item__content');
            headerContent.innerHTML = content.innerHTML;

            const { height } = headerContent.getBoundingClientRect();
            
            header.style.height = `${height}px`;
        });
    });

    navBar.addEventListener('mouseleave', (event) => {
        if (!navBar.contains(event.relatedTarget)) {
            hideContent();
        }
    });

    const hideContent = () => {
        if (activeLink) {
            activeLink.classList.remove('nav-item--active');
            activeLink = null;
        }

        header.classList.remove('header--active');
        header.style.removeProperty('height');
    };

    window.addEventListener('resize', resize);

    const resize = () => {
        const linksContainer = document.querySelector('.nav-bar__links');
        const rect = linksContainer.getBoundingClientRect();

        const { width, left } = rect;

        headerContent.style.width = `${width}px`;
        headerContent.style.left = `${left}px`;
    };
});
